/* [CUSTOM] Adds product tags to Shopify predictive search fields.
   Enables range-code search (HJ91 etc.) in the search dropdown.
   Patches window.fetch so it survives Prestige restructuring.
   Added: Aug 2026 — reapply after any theme update. */
(function () {
  var PARAM = 'resources[options][fields]';
  var DEFAULTS = 'title,product_type,variants.title,vendor,tag';

  function patch(rawUrl) {
    if (typeof rawUrl !== 'string' || rawUrl.indexOf('/search/suggest') === -1) {
      return null;
    }
    try {
      var url = new URL(rawUrl, window.location.origin);
      if (url.searchParams.has(PARAM)) {
        var existing = url.searchParams.get(PARAM);
        if (existing.split(',').indexOf('tag') !== -1) return null;
        url.searchParams.set(PARAM, existing + ',tag');
      } else {
        url.searchParams.set(PARAM, DEFAULTS);
      }
      return url.toString();
    } catch (e) {
      return null;
    }
  }

  var nativeFetch = window.fetch;
  window.fetch = function (resource, options) {
    try {
      if (typeof resource === 'string' || resource instanceof URL) {
        var p = patch(resource.toString());
        if (p) resource = p;
      } else if (typeof Request !== 'undefined' && resource instanceof Request) {
        var pr = patch(resource.url);
        if (pr) resource = new Request(pr, resource);
      }
    } catch (e) {}
    return nativeFetch.call(this, resource, options);
  };
})();